<template>
    <div>
        <div class="row">
            <div class="pull-right col-xl-12">
                <div class="pull-right">
                    <input-picker class="btn-one-size mr-1 ml-1 btn-one-size-custom pb-2" v-model="teamName" data-type="newsDashboardTeams"
                                  :label="$t('Team Name')" :placeholder="$t('Filter by team')" :clearable="true"/>
                    <el-select v-if="this.$route.name === 'News' || this.$route.name === 'NewsTeam'"
                               class="select-primary btn-one-size mr-1 ml-1 btn-one-size-custom"
                               :placeholder="$t('Sort Order')"
                               v-model="sf"
                               @change="init">
                        <el-option v-for="option in options"
                                   :value="option.value"
                                   :label="$t(option.label)"
                                   :key="option.value">
                        </el-option>
                    </el-select>
                    <p-button v-if="window.width >= 992" round type="danger" class="mr-1 ml-1" size="sm" icon style="margin-top: 5px"
                              @click="resetFilter">
                        <i class="fa fa-times"/>
                    </p-button>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="table-responsive">
                <el-table v-if="window.width >= 992" class="table-shopping" style="width: 100%" :showHeader="false" :data="news">
                    <el-table-column width="140">
                        <template slot-scope="props">
                            <div class="img-container">
                                <img v-if="props.row.image" :src="`/api/image/${props.row.image}`"
                                     onerror="this.src = '/static/img/placeholder.png'" alt="news image">
                                <img v-else src="/static/img/placeholder.png">
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="340" class-name="td-name">
                        <template slot-scope="{row}">
                            <div class="row">
                                <span class="ml-2 mr-2">
                                  <i :class="newsIcons[row.type]"/>
                                </span>
                                <div class="ml-2">
                                    <router-link tag="a" class="text-info"
                                                 :to="{ name: 'NewsDetails', params: { id: row._id } }">{{ row.team ? `${row.team.title} - ${row.title}` : row.title }}</router-link>
                                    <br/>
                                    <small class="text-muted">{{ $t('by {author}', { author: row.createdBy.username }) }}</small>
                                </div>
                            </div>
                            <br>
                            <div class="truncate-container">
                                <small class="truncate-content" v-dompurify-html="row.content"/>
                                <span>&nbsp;</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="160" fixed="right" class-name="td-name">
                        <template slot-scope="{row}">
                            <div class="pull-end">
                                <div class="pull-top">
                                    <small>{{ row.createdAt | formatDateTime }}</small>
                                </div>
                                <div class="text-right pull-bottom">
                                    <p-button aria-label="view button" type="primary" round icon size="sm"
                                              @click="() => $router.push({ name: 'NewsDetails', params: { id: row._id } })"><i class="nc-icon nc-minimal-right"/></p-button>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <el-table v-else class="table-shopping" style="width: 100%" :showHeader="false" :data="news">
                  <el-table-column>
                      <template slot-scope="props">
                        <news-box :news="props.row"/>
                      </template>
                  </el-table-column>
                </el-table>
                <div v-if="pagination" class="col-12">
                    <div class="col-sm-12 pt-3 m-0">
                        <p-pagination class="pull-center"
                                      :value="pagination.currentPage"
                                      :per-page="pagination.perPage"
                                      :total="pagination.total"
                                      @input="changePage">
                        </p-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import Vue from 'vue'
  import { mapActions, mapState } from 'vuex'
  import NewsBox from 'src/components/Dashboard/Components/NewsBox'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import { Table, TableColumn, Select, Option } from 'element-ui'
  import { newsIcons } from '../../../util/icons'
  import InputPicker from 'src/components/Dashboard/Components/InputPicker'

  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)

  export default {
    name: 'News',
    components: {
      NewsBox,
      PPagination,
      InputPicker
    },
    data () {
      return {
        sf: 'createdAt',
        so: 'desc',
        newsIcons,
        teamName: '',
        options: [
          {
            value: 'createdAt',
            label: 'Date'
          }, {
            value: 'title',
            label: 'Title'
          }
        ],
        window: {
          width: 0
        }
      }
    },
    beforeDestroy () {
      this.resetPaginator()
    },
    created() {
      window.addEventListener('resize', this.handleResize)
      this.handleResize();
    },
    mounted () {
      this.init()
    },
    computed: {
      ...mapState('news/pagination', {
        news: state => state.items,
        pagination: state => state
      })
    },
    methods: {
      ...mapActions('news/pagination', [
        'getNews',
        'resetPaginator'
      ]),

      async init () {
        const newPage = parseInt(this.$route.query.page, 10) || 1
        await this.getNews({
          perPage: this.pagination.perPage,
          page: newPage,
          sf: this.sf,
          so: this.so,
          teamId: this.teamName._id
        })
      },

      changePage (val) {
        const page = val > 1 ? val : undefined
        this.$router.push({ ...this.$router.currentRoute, query: { ...this.$route.query, page } })
      },
      resetFilter () {
        this.teamName = ''
        this.sf = 'createdAt'
        this.init()
      },
      handleResize() {
        this.window.width = window.innerWidth
      }
    },
    watch: {
      '$route.query.page' (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.init()
        }
      },
      'teamName' (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.init()
        }
      }
    }
  }
</script>
<style scoped>
    .truncate-container {
        position: relative;
    }

    .truncate-content {
        position: absolute;
        max-width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .pull-end {
        display: flex;
        justify-content: flex-end;
    }

    .pull-top {
        position: absolute;
        top: 12px;
    }

    .pull-bottom {
        position: absolute;
        bottom: 13px;
    }

    .el-table .cell {
        word-break: break-word;
        white-space: normal;
    }

    @media (max-width: 590px) {
      .btn-one-size-custom {
        width: 100%;
        padding-left: 0px;
        padding-right: 0px;
        padding-right: 5px !important;
      }
    }
</style>
